import {Directive, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {ConfirmationService} from 'primeng/api';
import {AppService} from '@shared/services/app.service';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[confirmSave]'
})
export class ConfirmSaveDirective {
    @Input() confirmMessage = 'Are you sure you want to save?';
    @Output() confirmSave = new EventEmitter<any>();

    constructor(private app: AppService) {
    }

    @HostListener('click')
    onClick() {
        this.app.confirmSave(() => {
            this.confirmSave.emit();
        });
    }
}
